import React from 'react';
import { Button, Input } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import styles from "../../styles/organism/captcha.module.css";

const Captcha = ({
  data, // { image, identifier }
  captchaChars,
  onChangeValue,
  refreshCaptcha
}) => {
  const getImageSrc = (image) => {
    if (!image) return '';
    if (image.startsWith('iVBOR')) {
      return `data:image/png;base64,${image}`;
    }
    return `data:image/jpeg;base64,${image}`;
  };

  return (
    <div className={styles.captcha} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Input
        className={styles.captchaText}
        value={captchaChars}
        onChange={onChangeValue}
        placeholder="Karakterleri girin"
        autoComplete="off"
        maxLength={6}
        style={{ marginBottom: 16, width: 200, textAlign: 'center' }}
      />
      <div className={styles.captchaImage} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        {data?.image ? (
          <img
            src={getImageSrc(data.image)}
            alt="captcha"
            style={{ width: 260, height: 100, objectFit: 'contain', borderRadius: 8, border: '1px solid #eee' }}
          />
        ) : (
          <span>Captcha yükleniyor...</span>
        )}
        <Button
          type="default"
          className={styles.captchaImageButton}
          icon={<ReloadOutlined />}
          onClick={refreshCaptcha}
        />
      </div>
    </div>
  );
};

export default Captcha;